import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TipoDocumental } from '../models/tipo-documental.model';
import { TipoDocumentalRepository } from '../repositories/tipo-documental.repository';
import { environment } from '../../../../environments/environment';
import { DEFAULT_PAGINATION_PARAMS, PaginatedResponse } from '../../../core/shared/models/pagination.model';
import { TipoDocumentalListParams } from '../models/tipo-documental-list-params.model';

@Injectable({
  providedIn: 'root'
})
export class TipoDocumentalService implements TipoDocumentalRepository {
  private readonly apiTipoDocumental = 'tipos-documentais/';

  constructor(private readonly http: HttpClient) { }

  listarTiposDocumentais(params: TipoDocumentalListParams = DEFAULT_PAGINATION_PARAMS): Observable<PaginatedResponse<TipoDocumental>> {
    let queryParams = new HttpParams()
      .set('page', params.page)
      .set('size', params.size);

    if (params.nome) {
      queryParams = queryParams.set('nome', params.nome);
    }

    if (params.status) {
      queryParams = queryParams.set('status', params.status);
    }

    return this.http.get<PaginatedResponse<TipoDocumental>>(
      `${environment.FI_FINANC_IMOB_BE}${this.apiTipoDocumental}listarTodos`,
      { params: queryParams }
    );
  }

  buscarTipoDocumentalPorId(id: number): Observable<TipoDocumental> {
    return this.http.get<TipoDocumental>(`${environment.FI_FINANC_IMOB_BE}${this.apiTipoDocumental}buscar/${id}`);
  }

  criarTipoDocumental(payload: TipoDocumental): Observable<TipoDocumental> {
    return this.http.post<TipoDocumental>(`${environment.FI_FINANC_IMOB_BE}${this.apiTipoDocumental}criar`, payload);
  }

  editarTipoDocumental(id: number, payload: TipoDocumental): Observable<TipoDocumental> {
    return this.http.put<TipoDocumental>(`${environment.FI_FINANC_IMOB_BE}${this.apiTipoDocumental}atualizar/${id}`, payload);
  }

  excluirTipoDocumental(id: number): Observable<void> {
    return this.http.delete<void>(`${environment.FI_FINANC_IMOB_BE}${this.apiTipoDocumental}deletar/${id}`);
  }
}


